import { SortOrder } from 'antd/es/table/interface';

import { FACTORY_TABLE_TEXTS_CONFIG } from './texts';

/**
 * Конфиг для управления направлением сортировки в таблице
 * ascend - сортировка по возрастанию
 * descend - сортировка по убыванию
 * Принцип сортировки: По возрастанию -> По убыванию -> По возрастанию
 * ( нет третьего состояния, когда нет никакой сортировки )
 * */
export const TABLE_SORT_DIRECTIONS_CONFIG: SortOrder[] = [
  'ascend',
  'descend',
  null,
];

export const getSortLabel = (direction: SortOrder): string => {
  if (!direction) {
    return FACTORY_TABLE_TEXTS_CONFIG.SORT_ASCEND;
  }

  if (direction === 'descend') {
    return FACTORY_TABLE_TEXTS_CONFIG.SORT_ASCEND;
  }

  return FACTORY_TABLE_TEXTS_CONFIG.SORT_DESCEND;
};
